module.exports = __webpack_public_path__ + "img/042-house.7bfdc59d.svg";